import { UPDATE_PROMO_CODE, UPDATE_PROMO_CODE_SUCCESS, UPDATE_PROMO_CODE_FAILURE } from "../actionTypes";

export const updatePromoCode = (payload) => ({
  type: UPDATE_PROMO_CODE,
  payload,
});

export const updatePromoCodeSuccess = () => ({
  type: UPDATE_PROMO_CODE_SUCCESS,
});

export const updatePromoCodeFailure = () => ({
  type: UPDATE_PROMO_CODE_FAILURE,
});
